import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'styled-components';
import { StoreProvider } from 'easy-peasy';

import Store from '~/state/Store';
import App from '~/App';
import GlobalStyles from '~/styles/Global';
import Theme from '~/styles/Theme';

const root = document.getElementById('root');

ReactDOM.render(
  <StoreProvider store={Store}>
    <ThemeProvider theme={Theme}>
      <>
        <GlobalStyles />
        <App />
      </>
    </ThemeProvider>
  </StoreProvider>,
  root
);
